<p-dialog [header]="isEditMode ? 'Edit SMS Template' : 'Create SMS Template'" [(visible)]="displayDialog" [modal]="true"
  [style]="{'width': '800px'}" (onHide)="onCloseDialog()">
  <form class="" #smsSettingsForm="ngForm">
    @if (selectedSmsTemplate) {
      <!-- Gradient Header -->
      <div class="bg-gradient text-white rounded-3 p-3 ">
        <div class="d-flex justify-content-between align-items-start">
          <div class="d-flex align-items-center">
            <div class="me-4">
              <i class="pi pi-comment fs-3 me-2"></i>
              <span class="fs-4 fw-bold">{{isEditMode ? 'Edit' : 'Create'}} SMS Template</span>
            </div>
            <div class="ms-4">
              <div class="fs-5 fw-semibold">{{selectedEmailEvent?.label}}</div>
              <div class="opacity-75 small mt-1">{{selectedEmailEvent?.data}}</div>
            </div>
          </div>
          <div class="d-flex gap-2">
            <button type="button" pButton class="p-button-outlined p-button-secondary p-button-rounded"
              (click)="showSMSPreviewDialog()" [disabled]="!selectedSmsTemplate.HtmlText" [pTooltip]="'smsSettingTemplateDailog.openSmsPreview' | transloco"
              tooltipPosition="top">
              <i class="pi pi-eye me-2"></i> {{ 'smsSettingTemplateDailog.preview' | transloco }}
            </button>
            <button type="button" pButton icon="pi pi-save" [label]="'smsSettingTemplateDailog.saveChanges' | transloco"
              class="p-button-success p-button-outlined p-button-rounded" (click)="saveSMSTemplate($event)"
              [disabled]="smsSettingsForm.invalid" [pTooltip]="'smsSettingTemplateDailog.saveSmsTemplate' | transloco" tooltipPosition="top">
            </button>
          </div>
        </div>
      </div>
      <!-- SMS Event Configuration -->
      <div class="row g-4 mb-4">
        <div class="col-12">
          <div class="border-0 shadow-sm">
            <div class="card-body p-4">
              <label class="form-label fw-bold" for="smsEventDropdown">
                <i class="fa fa-calendar-alt me-2 text-dark"></i>
                <span class="text-danger">*</span> {{ 'smsSettingTemplateDailog.smsEvent' | transloco }}
              </label>
              <div class="d-flex align-items-center gap-3">
                <div class="flex-grow-1">
                  <p-dropdown [(ngModel)]="selectedSmsTemplate.EmailEventId" [disabled]="isEditMode" [filter]="true"
                    [filterBy]="'label'" [optionLabel]="'label'" [optionValue]="'value'" [options]="emailEvents"
                    name="smsEventDropdown" id="smsEventDropdown" [placeholder]="'smsSettingTemplateDailog.selectEvent' | transloco"
                    (onChange)="onEmailEventChanged($event)" [required]="true" class="w-100 p-inputtext-lg">
                    <ng-template let-option pTemplate="item">
                      <div class="d-flex align-items-center">
                        <span [ngClass]="{'text-muted': option.disabled}">{{ option.label }}</span>
                        @if (option.IsPredefined) {
                          <span
                            class="badge"
                            [ngStyle]="{'background-color': '#178d9b', 'color': 'white'}">
                            {{ 'smsSettingTemplateDailog.system' | transloco }}
                          </span>
                        }
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>
                @if (!isEditMode) {
                  <p-button type="button" icon="fa fa-plus" [pTooltip]="'smsSettingTemplateDailog.addNewSmsEvent' | transloco"
                    class="p-button-outlined p-button-primary p-button-rounded" (click)="onAddSMSEvents()"
                    >
                  </p-button>
                }
              </div>
              <small class="text-dark">
                {{selectedEmailEvent?.data}}
              </small>
            </div>
          </div>
        </div>
      </div>
      <!-- SMS Parameters -->
      @if (emailParameters && emailParameters.length > 0) {
        <div class="row g-4 mb-3">
          <div class="col-12">
            <div class="card border-0 shadow-sm">
              <div class="card-header bg-light border-0 rounded-top">
                <h6 class="mb-0 text-success">
                  <i class="fa fa-code me-2"></i>{{ 'smsSettingTemplateDailog.smsParameters' | transloco }}
                </h6>
              </div>
              <div class="card-body p-3">
                <div class="d-flex flex-wrap gap-2">
                  @for (param of emailParameters; track param) {
                    <span
                      class="badge bg-secondary bg-gradient rounded-pill px-3 py-2 cursor-pointer user-select-none"
                      (click)="copySelectedSMSParameters(param)" [title]="'smsSettingTemplateDailog.clickToCopy' | transloco: { name: param.ParameterName }"
                      style="cursor: pointer; transition: all 0.2s ease;">
                      <i class="fa fa-copy me-1"></i>{{param.ParameterName}}
                    </span>
                  }
                </div>
                @if (emailParameters.length === 0) {
                  <div class="text-center text-muted">
                    <i class="fa fa-inbox fs-3 mb-2"></i>
                    <p class="small">{{ 'smsSettingTemplateDailog.noParametersAvailable' | transloco }}</p>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
      <!-- SMS Parameter Dropdown for Insert -->
      @if (!isEditMode && selectedSmsTemplate.EmailEventId && loadedEmailTemplateParameters) {
        <div class="row g-4 mb-3"
          >
          <div class="col-12">
            <div class="card border-0 shadow-sm">
              <div class="card-header bg-light border-0 rounded-top">
                <h6 class="mb-0 text-success">
                  <i class="fa fa-cogs me-2"></i>{{ 'smsSettingTemplateDailog.parameterManager' | transloco }}
                </h6>
              </div>
              <div class="card-body p-3">
                <label class="form-label fw-bold" for="smsParamDropdown">
                  <i class="fa fa-cogs me-1"></i>{{ 'smsSettingTemplateDailog.smsParameter' | transloco }}
                </label>
                <div class="row g-2">
                  <div class="col-8">
                    <p-dropdown [(ngModel)]="selectedEmailParameter" [options]="emailParameters" name="smsParamDropdown"
                      id="smsParamDropdown" [filter]="true" [filterBy]="'ParameterName'" [optionLabel]="'ParameterName'"
                      [optionValue]="'Guid'" [placeholder]="'smsSettingTemplateDailog.selectParameter' | transloco" class="w-100 p-inputtext-lg"
                      (onChange)="onEmailParameterChanged($event)" [pTooltip]="'smsSettingTemplateDailog.selectAParameterToInsert' | transloco"
                      tooltipPosition="top">
                    </p-dropdown>
                  </div>
                  <div class="col-4">
                    <button type="button" pButton icon="fa fa-plus" [label]="'smsSettingTemplateDailog.insert' | transloco"
                      class="p-button-primary p-button-outlined p-button-rounded w-100"
                      (click)="insertSMSParameter($event)" [disabled]="!selectedEmailParameter"
                      [pTooltip]="'smsSettingTemplateDailog.insertTheSelectedParameter' | transloco" tooltipPosition="top">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- SMS Content Textarea -->
      <div class="row g-4">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-3">
              <div class="mb-4">
                <label class="form-label fw-bold" for="smsContent">
                  <i class="fa fa-comment me-2 "></i>{{ 'smsSettingTemplateDailog.smsContent' | transloco }}
                </label>
                <textarea class="form-control form-control-lg" name="smsContent" id="smsContent"
                  [(ngModel)]="selectedSmsTemplate.HtmlText" rows="6"
                  [placeholder]="'smsSettingTemplateDailog.writeYourSmsTemplateHere' | transloco" maxlength="160"
                [pTooltip]="'smsSettingTemplateDailog.enterTheSmsContent' | transloco" tooltipPosition="top"></textarea>
                <div class="form-text text-muted small">
                  <i class="fa fa-lightbulb me-1"></i>
                  {{ 'smsSettingTemplateDailog.writeYourSmsContentHint' | transloco }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </form>
</p-dialog>

<!-- SMS Preview Sidebar -->
<p-sidebar [(visible)]="smsPreviewVisible" position="right" [style]="{'width': '720px'}">
  <!-- Main Content -->
  <div class="p-3">
    @if (selectedSmsTemplate?.HtmlText) {
      <!-- SMS Preview Section -->
      <div class="card border-0 shadow-sm mb-4">
        <div class="card-header bg-light border-0 rounded-top">
          <h6 class="mb-0 text-dark">
            <i class="fa fa-eye me-2"></i>{{ 'smsSettingTemplateDailog.smsPreview' | transloco }}
          </h6>
        </div>
        <div class="card-body p-4">
          <p class="text-muted small mb-3">
            <i class="fa fa-info-circle me-1"></i>
            {{ 'smsSettingTemplateDailog.previewYourSmsTemplate' | transloco }}
          </p>
          <div [innerHTML]="selectedSmsTemplate.HtmlText | safeHtml" class="border rounded-3 p-3" id="smsCodePreview">
          </div>
        </div>
      </div>
      <!-- Test SMS Section -->
      <div class="card border-0 shadow-sm mb-4">
        <div class="card-header bg-light border-0 rounded-top">
          <h6 class="mb-0 text-dark">
            <i class="fa fa-send me-2"></i>{{ 'smsSettingTemplateDailog.testSms' | transloco }}
          </h6>
        </div>
        <div class="card-body p-4">
          <p class="text-muted small mb-3">
            <i class="fa fa-lightbulb me-1"></i>
            {{ 'smsSettingTemplateDailog.enterValidPhoneToSendTest' | transloco }}
          </p>
          <div class="row align-items-center g-2">
            <div class="col-9">
              <input type="tel" class="form-control form-control-lg" name="phone" id="phone"
                [placeholder]="'smsSettingTemplateDailog.phonePlaceholder' | transloco" [(ngModel)]="testPhoneNumber"
                [pTooltip]="'smsSettingTemplateDailog.enterValidPhoneToTest' | transloco" tooltipPosition="top" />
              </div>
              <div class="col-3">
                <button type="button" pButton icon="fa fa-send" [label]="'smsSettingTemplateDailog.sendTestSms' | transloco"
                  class="p-button-outlined p-button-primary p-button-rounded w-100" (click)="sendTestSMS($event)"
                  [pTooltip]="'smsSettingTemplateDailog.clickToSendTestSms' | transloco" tooltipPosition="top">
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Tips Section -->
        <div class="card border-0 shadow-sm">
          <div class="card-header bg-light border-0 rounded-top">
            <h6 class="mb-0 text-dark">
              <i class="fa fa-info-circle me-2"></i>{{ 'smsSettingTemplateDailog.tips' | transloco }}
            </h6>
          </div>
          <div class="card-body p-4">
            <ul class="text-muted small">
              <li><i class="fa fa-check me-1"></i>{{ 'smsSettingTemplateDailog.tipPhoneValid' | transloco }}</li>
              <li><i class="fa fa-eye me-1"></i>{{ 'smsSettingTemplateDailog.tipKeepWithin160' | transloco }}</li>
              <li><i class="fa fa-mobile me-1"></i>{{ 'smsSettingTemplateDailog.tipTestDevices' | transloco }}</li>
            </ul>
          </div>
        </div>
      }

      <!-- No Template Selected -->
      @if (!selectedSmsTemplate?.HtmlText) {
        <div class="alert alert-info border-0 bg-info bg-opacity-10 text-center p-4">
          <small class="text-info">
            <i class="fa fa-info-circle me-1"></i>
            {{ 'smsSettingTemplateDailog.noSmsTemplateSelected' | transloco }}
          </small>
        </div>
      }
    </div>
  </p-sidebar>



  <!-- Add SMS Event Dialog -->
  @if (isAddSMSEventDailogVisible) {
    <sms-events-dailog [isAddEmailEventDailogVisible]="isAddSMSEventDailogVisible"
      [emailEventsFormData]="emailEventsFormData" [emailParameters]="emailParametersForAddEvents"
      (getEmailEvents)="fetchEmailEvents()" (onCloseEmailEventDailog)="onCloseSMSEventsDialog($event)">
    </sms-events-dailog>
  }